import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { OtpServiceService } from '../otp-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-send-otp',
  templateUrl: './send-otp.component.html',
  styleUrls: ['./send-otp.component.scss']
})
export class SendOtpComponent {
  hide = true;

  constructor(
    private otpServiceService: OtpServiceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService
  ) {}

  sendOtp(sendOTPForm: NgForm) {
    this.spinnerService.showSpinner$.next(true);
    this.otpServiceService.sendOtp(sendOTPForm.form.value).subscribe({
      next: () => {
        this.snackBar.open("Success", 'OTP was sent');
        this.router.navigate(['/delete-account-step2']);
        this.spinnerService.showSpinner$.next(false);
      },
      error: (err) => {
        this.snackBar.open(err.message, 'Error');
        this.spinnerService.showSpinner$.next(false);
      },
    });
  }
}
